import CommandTypes from '../../../Canvas/commands/types';
import add from './add';

const calloutCommands = {
    [CommandTypes.CREATE_SHAPES]: add
};

export default calloutCommands;
